// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._nEo84PMZac_kv0P3jIH {
  margin-top: var(--spacing-medium);
  overflow-x: auto;
}

.cm0LDHEi6dHewP_7nbbz {
  margin-top: var(--spacing-xSmall);
}
`, "",{"version":3,"sources":["webpack://./src/App/views/DependentsData/DependentsData.module.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":[".table-list {\n  margin-top: var(--spacing-medium);\n  overflow-x: auto;\n}\n\n.empty-state-action-button {\n  margin-top: var(--spacing-xSmall);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table-list": `_nEo84PMZac_kv0P3jIH`,
	"empty-state-action-button": `cm0LDHEi6dHewP_7nbbz`
};
export default ___CSS_LOADER_EXPORT___;
